import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import MfprintingtypeDashboard from '../MfprintingtypeDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function MfprintingtypePage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < MfprintingtypeDashboard />
    )

}